const payout_types = [
    { payoutMode: 1, description: "1st Cutoff", biMonthlyOnly: true },
    { payoutMode: 2, description: "2nd Cutoff", biMonthlyOnly: true },
    { payoutMode: 3, description: "Split Per Cutoffs", biMonthlyOnly: true },
    { payoutMode: 4, description: "Once A Month", biMonthlyOnly: false }
];
export default payout_types;

export function getPayoutTypes(isBiMonthlyCutoff) {
    return payout_types.filter(x => x.biMonthlyOnly === isBiMonthlyCutoff)
}